<template>
  <b-container fluid class="contendordepagina">
    <b-sidebar
      id="sidebar-1"
      :title="$t('lang.misfacturas.filtro.label')"
      shadow
      right
    >
      <div class="px-3 py-2">
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              :placeholder="$t('lang.misfacturas.filtro.placeholder')"
            ></b-form-input>
            <b-input-group-append
              v-b-popover.hover="
                'Busca el texto contenido en Factura, Factra rect. y Empresa'
              "
              title="¿Dónde busca?"
              ><b-icon-question-circle
                font-scale="2.1"
                class="ml-1"
              ></b-icon-question-circle
            ></b-input-group-append>
            <!-- <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">{{
                $t("lang.misfacturas.filtro.limpiar")
              }}</b-button>
            </b-input-group-append> -->
          </b-input-group>
        </b-form-group>

        <b-form-group :label="$t('lang.misfacturas.tabla.fecha')">
          <b-input-group :prepend="$t('lang.misfacturas.filtro.desde')">
            <b-form-datepicker
              v-model="fechadesde"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              reset-button
              placeholder=""
              @input="filtros()"
            ></b-form-datepicker>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group :prepend="$t('lang.misfacturas.filtro.hasta')">
            <b-form-datepicker
              v-model="fechahasta"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              reset-button
              placeholder=""
              @input="filtros()"
            ></b-form-datepicker>
          </b-input-group>
        </b-form-group>

        <b-form-group :label="$t('lang.misfacturas.tabla.vencimiento')">
          <b-input-group :prepend="$t('lang.misfacturas.filtro.desde')">
            <b-form-datepicker
              v-model="vencimientodesde"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              reset-button
              placeholder=""
              @input="filtros()"
            ></b-form-datepicker>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group :prepend="$t('lang.misfacturas.filtro.hasta')">
            <b-form-datepicker
              v-model="vencimientohasta"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              reset-button
              placeholder=""
              @input="filtros()"
            ></b-form-datepicker>
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <label>{{ $t("lang.misfacturas.tabla.estado") }}</label
          ><br />
          <b-form-select
            v-model="estado"
            :options="optEstados"
            @change="filtros()"
          ></b-form-select>
        </b-form-group>
      </div>
    </b-sidebar>
    <div class="mx-0 mx-md-5">
      <b-row>
        <b-col>
          <b-pagination
            class="mt-5 mt-md-0"
            v-model="currentPage"
            :total-rows="totalItemsFiltrados"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination
        ></b-col>
        <b-col class="text-right"
          ><b-button
            v-b-toggle.sidebar-1
            variant="light"
            style="color:var(--color-manusa-azul)"
            ><b-icon-filter></b-icon-filter>
            {{ $t("lang.misfacturas.filtro.label") }}</b-button
          ></b-col
        >
      </b-row>
      <div class="font-italic">{{ resultadofiltro }}</div>
      <b-table
        stacked="sm"
        striped
        hover
        :fields="fields"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
        small
        :busy="cargandoitems"
        no-provider-paging
        no-provider-sorting
        no-provider-filtering
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        :tbody-tr-class="rowClass"
        :filter="filter"
        :filter-included-fields="[
          'Empresa',
          'id_factura',
          'Cod_FacturaRectificada',
          'cod_Proyecto',
        ]"
        @filtered="onFiltered"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="10"></b-th>
            <!-- <b-th class="text-right">{{ total1 }}</b-th>
            <b-th class="text-right">{{ total2 }}</b-th>
            <b-th class="text-right">{{ total3 }}</b-th> -->
            <b-th class="text-right" style="font-size: 1.2em;">{{
              total4
            }}</b-th>
          </b-tr>
        </template>

        <template v-slot:cell(actions)="row">
          <a
            href="#"
            @click.prevent="descargarfactura(row.item, 'pdf')"
            title="Descargar PDF"
            ><b-img src="/img/ic-pdf.png" height="30px"></b-img
          ></a>
          <a
            href="#"
            @click.prevent="descargarfactura(row.item, 'xml')"
            title="Descargar PDF"
            ><b-img src="/img/ic-xml.png" height="30px"></b-img
          ></a>
          <b-button
            @click="masInfo(row.item, row.index, $event.target)"
            class="mr-1 bgcolor-manusa"
          >
            <b-icon-plus-square></b-icon-plus-square> Info
          </b-button>
          <!-- <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? "Hide" : "Show" }} Details
          </b-button> -->
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>
    </div>

    <!-- Info modal -->
    <b-modal
      :id="infoModal.id"
      :title="infoModal.titulo"
      ok-only
      @hide="resetInfoModal"
    >
      <h3 class="w-100 d-flex justify-content-between">
        Total: {{ formatoMoneda(infoModal.importe) }}<br />
        <small v-show="infoModal.importe_pendiente > 0" class="facturapendiente"
          >Pendiente: {{ formatoMoneda(infoModal.importe_pendiente) }}</small
        >
      </h3>
      <div v-if="infoModal.vencimientos.length">
        <h3>Liquidaciones</h3>
        <b-list-group>
          <b-list-group-item v-for="it in infoModal.vencimientos" :key="it.ID"
            >{{ $moment(it.Fecha_vencimiento).format("DD/MM/YYYY") }} -
            {{ it.Estado }}: {{ formatoMoneda(it.importe) }}</b-list-group-item
          >
        </b-list-group>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
//Number.prototype.numberFormat = function(decimals, dec_point, thousands_sep) { dec_point = typeof dec_point !== 'undefined' ? dec_point : '.'; thousands_sep = typeof thousands_sep !== 'undefined' ? thousands_sep : ','; var parts = this.toFixed(decimals).split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep); return parts.join(dec_point); }
function formatNumber(num, fixed) {
  var decimalPart;
  var esNegativo = num < 0;
  var array = Math.floor(Math.abs(num))
    .toString()
    .split("");
  var index = -3;
  while (array.length + index > 0) {
    array.splice(index, 0, ".");
    index -= 4;
  }
  if (fixed > 0) {
    decimalPart = parseFloat(num)
      .toFixed(fixed)
      .split(".")[1];
    return (esNegativo ? "-" : "") + array.join("") + "," + decimalPart;
  }

  return (esNegativo ? "-" : "") + array.join("");
}
export default {
  data() {
    return {
      sortBy: "Fecha",
      sortDesc: true,
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        importe_pendiente: 0,
        importe: 0,
        titulo: "",
        vencimientos: [],
      },
      fields: [
        {
          key: "id_factura",
          label: this.$t("lang.misfacturas.tabla.factura"),
          class: "align-middle",
        },
        {
          key: "Cod_FacturaRectificada",
          label: this.$t("lang.misfacturas.tabla.facturarect"),
          class: "align-middle",
        },
        {
          key: "Fecha",
          label: this.$t("lang.misfacturas.tabla.fecha"),
          class: "align-middle",
          formatter: (value) => {
            return this.$moment(value).format("DD/MM/YYYY");
          },
          sortable: true,
          sortByFormatted: false,
          filterByFormatted: false,
        },
        {
          key: "Fecha_vencimiento",
          class: "align-middle",
          label: this.$t("lang.misfacturas.tabla.vencimiento"),
          formatter: (value) => {
            return this.$moment(value).format("DD/MM/YYYY");
          },
          sortable: true,
          sortByFormatted: false,
        },
        {
          key: "Empresa",
          label: this.$t("lang.misfacturas.tabla.empresa"),
          class: "align-middle",
          sortable: true,
        },
        {
          key: "cod_Proyecto",
          class: "align-middle",
          label: this.$t("lang.misfacturas.tabla.pedido"),
          sortable: true,
        },
        {
          key: "Estado",
          label: this.$t("lang.misfacturas.tabla.estado"),
          class: ["text-center", "align-middle"],
          sortable: true,
        },
        {
          key: "importe",
          label: this.$t("lang.misfacturas.tabla.importe"),
          formatter: (value) => {
            return this.formatoMoneda(value);
          },
          class: ["text-right", "align-middle"],
          sortable: false,
        },
        {
          key: "importe_iva",
          label: this.$t("lang.misfacturas.tabla.iva"),
          formatter: (value) => {
            return this.formatoMoneda(value);
          },
          class: ["text-right", "align-middle"],
          sortable: false,
        },
        {
          key: "importe_iva_inc",
          label: this.$t("lang.misfacturas.tabla.total"),
          formatter: (value) => {
            return this.formatoMoneda(value);
          },
          class: ["text-right", "align-middle"],
          sortable: false,
        },
        {
          key: "importe_pendiente",
          label: this.$t("lang.misfacturas.tabla.pendiente"),
          formatter: (value) => {
            return this.formatoMoneda(value);
          },
          class: ["text-right", "align-middle"],
          sortable: false,
        },
        { key: "actions", label: "", class: "text-center" },
      ],
      itemsoriginal: [],
      items: [],
      itemsFiltrados: [],
      currentPage: 1,
      perPage: 15,
      totalItemsFiltrados: 0,
      cargandoitems: true,
      resultadofiltro: "",
      fechadesde: "",
      fechahasta: "",
      vencimientodesde: "",
      vencimientohasta: "",
      estado: "",
      optEstados: [],
    };
  },
  mounted() {
    this.$store.commit("SET_SECCION", this.$t("lang.rutas.misfacturas"));
    this.cargaritems();
    this.optEstados = [
      { value: null, text: "" },
      { value: "Pendiente", text: "Pendiente" },
      { value: "Liquidada", text: "Liquidada" },
      { value: "Vencida", text: "Vencida" },
      { value: "Abono", text: "Abono" },
    ];
  },
  methods: {
    formatoMoneda(value) {
      //return (parseInt(parseFloat(value) * 100) / 100).toLocaleString() + "€";
      //return parseFloat(value).toFixed(2) + "€";
      //return Intl.NumberFormat().format(value);

      let txt = formatNumber(value, 2);
      //console.log(txt);
      txt = txt.split(",").join("|");
      //console.log(txt);
      txt = txt.split(".").join(",");
      //console.log(txt);
      txt = txt.split("|").join(".");
      //console.log(txt);
      return txt + "€";
    },
    descargarfactura(it, formato) {
      console.log("descargado", it, formato);
      const params = {
        origen: it.NIF_Origen,
        anno: this.$moment(it.Fecha).format("Y"),
        vat: it.Cod_cliente,
        id: it.id_factura,
        formato: formato,
      };
      //var _t = this;
      this.axios
        .post("efacturaclientes/descargar-factura", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then((res) => {
          const nombre = it.Cod_cliente + "." + formato;

          //console.log("descargado", res);
          if (res.status === 401) document.location.href = "/";
          if (res.status > 400) return;
          //document.location.href = res.data;
          console.log("descargado", res.data);
          //this.showFile(res.data);

          if (formato === "pdf") {
            var byteCharacters = atob(res.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            this.showFile(byteArray, "application/pdf", nombre);
          } else {
            this.showFile(res.data, "text/xml", nombre);
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    },
    showFile(blob, contenttype, nombre) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: contenttype });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = nombre;
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },

    cargaritems() {
      this.items = [];
      var _t = this;
      this.axios
        .post(
          "efacturaclientes/buscar-facturas",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          if ("error" in res.data && res.data.error === "SESIONCADUCADA")
            document.location.href = "/";
          _t.itemsoriginal = res.data.items;
          _t.itemsoriginal.forEach((it) => {
            _t.items.push(it);
          });
          _t.cargandoitems = false;
          _t.onFiltered(res.data.items);
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      let dv = this.$moment().diff(
        this.$moment(item.Fecha_vencimiento),
        "days"
      );
      if (dv < 100 && item.importe_pendiente > 0) return "facturapendiente";
      if (item.importe_pendiente > 0) return "text-info";
      if (item.Estado === "Vencida") return "facturavencida";
      // console.log(
      //   "dv",
      //   dv,
      //   item.id_factura,
      //   this.$moment(item.Fecha_vencimiento),
      //   this.$moment()
      // );
    },
    masInfo(item, index, button) {
      this.infoModal.titulo =
        "Factura " + item.id_factura + " - " + item.Estado;
      this.infoModal.importe_pendiente = item.importe_pendiente;
      this.infoModal.importe = item.importe_iva_inc;
      var _t = this;
      this.axios
        .post(
          "efacturaclientes/buscar-vencimientos",
          {
            b: {
              id_factura: item.id_factura,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          if ("error" in res.data && res.data.error === "SESIONCADUCADA")
            document.location.href = "/";

          //console.log(item, index, button);
          _t.infoModal.vencimientos = res.data.items;
          _t.$root.$emit("bv::show::modal", _t.infoModal.id, button);
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    },
    resetInfoModal() {
      this.infoModal.titulo = "";
      this.infoModal.vencimientos = [];
      this.importe_pendiente = 0;
      this.importe = 0;
    },
    filtros() {
      let itemsporfechas = [];

      // console.log(
      //   "itemsporfechas",
      //   this.vencimientodesde,
      //   this.vencimientohasta
      // );
      this.itemsoriginal.forEach((it) => {
        if (
          (this.fechadesde.length !== 10 ||
            (this.fechadesde.length === 10 &&
              this.$moment(it.Fecha).format("YYYYMMDD") >=
                this.$moment(this.fechadesde, "YYYY-MM-DD").format(
                  "YYYYMMDD"
                ))) &&
          (this.fechahasta.length !== 10 ||
            (this.fechahasta.length === 10 &&
              this.$moment(it.Fecha).format("YYYYMMDD") <=
                this.$moment(this.fechahasta, "YYYY-MM-DD").format(
                  "YYYYMMDD"
                ))) &&
          (this.vencimientodesde.length !== 10 ||
            (this.vencimientodesde.length === 10 &&
              this.$moment(it.Fecha_vencimiento).format("YYYYMMDD") >=
                this.$moment(this.vencimientodesde, "YYYY-MM-DD").format(
                  "YYYYMMDD"
                ))) &&
          (this.vencimientohasta.length !== 10 ||
            (this.vencimientohasta.length === 10 &&
              this.$moment(it.Fecha_vencimiento).format("YYYYMMDD") <=
                this.$moment(this.vencimientohasta, "YYYY-MM-DD").format(
                  "YYYYMMDD"
                ))) &&
          (!this.estado || (this.estado && this.estado === it.Estado))
        )
          itemsporfechas.push(it);
      });

      this.items = itemsporfechas;
      this.onFiltered(this.items);
    },
    onFiltered(itemsFiltrados) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (itemsFiltrados) this.itemsFiltrados = itemsFiltrados;
      this.totalItemsFiltrados = this.itemsFiltrados.length;
      this.currentPage = 1;

      this.resultadofiltro =
        this.$t("lang.misfacturas.facturasencontradas", {
          num: this.itemsoriginal.length,
        }) +
        (this.itemsFiltrados.length === this.itemsoriginal.length
          ? ""
          : " (" +
            this.$t("lang.misfacturas.filtradas", {
              num: this.itemsFiltrados.length,
            }) +
            ")");
    },
  },
  computed: {
    total1() {
      let suma = 0;
      if (this.itemsFiltrados) {
        this.itemsFiltrados.forEach((it) => {
          suma += parseFloat(it.importe);
        });
      }
      return this.formatoMoneda(suma);
    },
    total2() {
      let suma = 0;
      if (this.itemsFiltrados) {
        this.itemsFiltrados.forEach((it) => {
          suma += parseFloat(it.importe_iva);
        });
      }
      return this.formatoMoneda(suma);
    },
    total3() {
      let suma = 0;
      if (this.itemsFiltrados) {
        this.itemsFiltrados.forEach((it) => {
          suma += parseFloat(it.importe_iva_inc);
        });
      }
      return this.formatoMoneda(suma);
    },
    total4() {
      let suma = 0;
      if (this.itemsFiltrados) {
        this.itemsFiltrados.forEach((it) => {
          suma += parseFloat(it.importe_pendiente);
        });
      }
      return this.formatoMoneda(suma);
    },
  },
};
</script>
<style></style>
